import {Component, OnInit} from '@angular/core';
import {MessageDisplayService} from '../shared/services/message-display.service';
import {LoanService} from '../shared/services/loan.service';
import {MessageDisplayModel} from '../shared/message/messageDisplay.model';
import {MortgageDisplay} from '../shared/models/mortgage-display.model';
import {ImagedDocumentService} from '../shared/services/imaged-document.service';
import {ImagedDocumentsList} from '../shared/models/imaged-documents-list.model';
import {ImagedDocumentsFactory} from '../shared/factories/imaged-documents.factory';
import {ImagedDocument} from '../shared/models/imaged-document.model';
import {DomSanitizer, Title} from '@angular/platform-browser';

@Component({
  selector: 'app-loan-images',
  styleUrls: ['./loan-images.component.scss'],
  templateUrl: './loan-images.component.html'
})
export class LoanImagesComponent implements OnInit {

  messageDisplay: MessageDisplayModel = new MessageDisplayModel();

  searchString = '';
  documentString = 'document';
  cursor = 1;
  loanSearching = false;
  loanError = false;
  loanSearchError = '';
  mortgageDisplay: MortgageDisplay;
  public pageNumber = 1;
  public pageSize = 30;
  public lastPage: number;
  documentName = 'All';
  sortBy = 'DocType';
  public iconList: string[] = [];
  public errorCountList: number[] = [];
  loanId = '';
  public documentPdfLink: any;

  public sortOptions: string[] = [
    'DocType',
    'Date Added'
  ];

  private sortKeys: string[] = [
    'documentType',
    'documentDate'
  ];

  public firstResult = 0;
  public lastResult = 0;
  public totalRows = 0;

  //public categories: string[];

  public documents: ImagedDocument[];
  public displayDocuments: ImagedDocument[];
  public doc: string;
  public isDoneGrabbing: boolean;

  // table stuff
  hasListeners = false;
  hasValues = false;
  internalCheckedState: any = {};

  public headings: Array<any> = [
    { data: 'DocType', class: 'doc-name'},
    { data: 'Category', class: 'doc-type' },
    { data: 'Type', class: 'doc-pdf' },
    { data: 'Pages', class: 'doc-pages'},
    { data: 'Date Added', class: 'doc-date' }
  ];
  documentCategory: string;
  sortByString: string;

  constructor(private loanService: LoanService,
              private messageDisplayService: MessageDisplayService,
              public sanitizer: DomSanitizer,
              private documentService: ImagedDocumentService,
              private titleService: Title) {
  }

  ngOnInit() {
    this.titleService.setTitle('Arvest Business Partner Portal: Imaged Documents');
  }

  searchLoan() {
    if (this.messageDisplayService.hasMessage()) {
      this.messageDisplayService.clearMessage();
    }
    this.loanSearching = true;
    this.isDoneGrabbing = false;
    this.loanError = false;
    this.loanSearchError = '';
    //this.categories = undefined;
    this.iconList = [];
    if (this.searchString.trim().length === 0) {
      this.loanError = true;
      this.loanSearchError = 'Missing Loan Number';
      this.loanSearching = false;
      this.isDoneGrabbing = true;
      return;
    }
    this.loanService.getLoanDetail(this.searchString)
      .then((response: any) => {
        this.mortgageDisplay = response;
        this.searchString = '';
        this.loanSearching = false;
        this.loanId = this.mortgageDisplay.loanNumber;
        this.cursor = 1;
        this.fetchNewRecords(1);
      })
      .catch((error: any) => {
        this.loanError = true;
        if (error.error && error.error.developerMessage) {
          this.loanSearchError = error.error.developerMessage;
        } else {
          this.loanSearchError = error.message;
        }
        console.error(error);
        this.loanSearching = false;
      });
  }

  loadDocuments() {
    this.iconList = [];
    this.documentService.getDocumentsByLoanId(this.loanId, this.cursor.toString(), this.documentName, this.sortBy)
      .then((imagedDocumentList: ImagedDocumentsList) => {
        if (imagedDocumentList && imagedDocumentList.statusMessage === "Success"
          && imagedDocumentList.documents.length > 0)
          {
            // main document list data
            this.documents = imagedDocumentList.documents;
            console.log("documents", this.documents);

            // total rows needs to be set before pagination
            this.totalRows = this.documents.length;
            console.log("total rows", this.totalRows);

            // sort documents
            this.updateSort(this.sortBy); // the default

            this.keepGrabbing();
        } else {
          this.messageDisplay = this.messageDisplayService.createPassiveMessageDisplayWithGivenMessage(
            'There are currently no imaged documents for the selected loan.'
          );
        }
      }).catch( error => {
      console.log('Error: ', error);
      this.messageDisplay = this.messageDisplayService.createErrorMessageDisplay(
        'GENERIC_PROBLEM');
    });
  }

  setPagination() {
    console.log("setPagination");
    this.firstResult = 30 * (this.cursor - 1) + 1;
    this.lastResult = this.firstResult + 30 <= this.totalRows ? this.firstResult + 29 : this.totalRows;
    this.lastPage = Math.ceil(this.totalRows / 30);
  }

  async getImagedDocument(doc, index) {
    if (this.messageDisplayService.hasMessage()) {
      this.messageDisplayService.clearMessage();
    }
    this.messageDisplay = null;
    if (this.iconList[index] === 'warning') {
      this.messageDisplay = this.messageDisplayService.createErrorMessageDisplay(
        'DOCUMENT_TOO_LARGE');
    } else {
      this.iconList[index] = 'spinner';
      await this.documentService.getDocumentById(this.loanId, doc).then( b64 => {
        console.log("b64", b64);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          console.log("save open blob");
          this.documentPdfLink = window.navigator.msSaveOrOpenBlob(this.convertDataURIToBinary(b64[this.documentString]), `${doc}.pdf`);
        } else {
          console.log("else option")
          const url = window.URL.createObjectURL(b64);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${doc}.pdf`;
          document.body.appendChild(a);
          a.click();
          //this.iconList[index] = 'check';
        }
      }).catch( error => {
        console.log('Error on load: ', error);
        this.iconList[index] = 'priority_high';
        this.errorCountList[index]++;
        if (this.errorCountList[index] >= 3) {
          this.messageDisplay = this.messageDisplayService.createErrorMessageDisplay(
            'DOCUMENT_ERROR_MANY');
        } else {
          this.messageDisplay = this.messageDisplayService.createErrorMessageDisplay(
            'DOCUMENT_ERROR');
        }
      });
    }
  }

  convertDataURIToBinary(base64) {
    const byteArray = Uint8Array.from(
      atob(base64).split('').map(char => char.charCodeAt(0))
    );
    return new Blob([byteArray], {type: 'application/pdf'});
  }

  getIDs(row: number, data: any) {
    let rowPrefix = row.toString();
    rowPrefix += '-';

    if (this.is_array(data)) {
      let retVal = '';
      for (const item of data) {
        if (typeof item !== 'undefined' && typeof item.data !== 'undefined') {
          retVal += `${rowPrefix}${item.data.replace(/\s/g, '_')} `;
        }
      }
      return retVal;
    } else {
      if (typeof data === 'undefined') {
        return rowPrefix;
      } else {
        return `${rowPrefix}${data.data.replace(/\s/g, '_')}`;
      }
    }
  }

  fixSpaces(val: string) {
    if (typeof val === 'undefined') {
      return '';
    } else {
      return val.replace(/\s/g, '_');
    }
  }

  async keepGrabbing() {
    console.log("starting keepGrabbing");
    //const limit = Math.ceil(this.totalRows / 30);
    //let newDocuments: ImagedDocumentsList;
    // const newCategories: string[] = [];
    // // only request once
    // for (let i = 1; i <= 1; i++) {
    //   newDocuments = await this.documentService.getDocumentsByLoanId(this.loanId, i.toString(), this.documentName, this.sortBy);
    //   newDocuments.documents.forEach( (document: ImagedDocument) => newCategories.push(document.documentType));
    // }
    // const uniqueDocTypes = new Set(newCategories);
    //this.categories = [...uniqueDocTypes].sort();
    //this.categories.unshift('All');
    //this.documentCategory = this.categories[0];

    this.isDoneGrabbing = true;
    console.log("keepGrabbing()");
    //console.log("sortByString", this.sortByString);
    console.log("isDoneGrabbing", this.isDoneGrabbing);
  }

  public is_array(item) {
    return Array.isArray(item);
  }

  updateCategory(category) {
    this.documentName = category;
    this.cursor = 1;
    this.loadDocuments();
  }

  updateSort(sort) {
    // reset paging
    this.cursor = 1;
    this.pageNumber = 1;
    console.log("sort", sort);

    // sort key or field name in list
    const sortIndex = this.sortOptions.indexOf(sort);
    console.log("sortIndex", sortIndex);
    const sortKey = this.sortKeys[sortIndex];
    console.log("sortKey", sortKey);

    this.sortByString = this.sortOptions[sortIndex];
    console.log("sortByString", this.sortByString);

    // sort this.documents
    switch(sortKey)
    {
      case "documentDate": // special case because date
        this.documents.sort((a, b) => new Date(a.documentDate).getTime() - new Date(b.documentDate).getTime());
      break;
      default: // only documentType right now
        this.documents.sort((a, b) => a.documentType.localeCompare(b.documentType));
        break;
    }

    console.log("documents", this.documents);

    // set displayDocument
    this.displayDocuments = ImagedDocumentsFactory.formatImagedDocumentsForTable(this.documents);
    console.log("display documents", this.displayDocuments);

    this.setPagination();
  }

  fetchNewRecords(page: number) {
    this.pageNumber = page;
    this.cursor = page;
    this.loadDocuments();
  }

  changePage(page: number) {
    console.log('changePage', page);
    this.pageNumber = page;
    this.cursor = page;
    // update this
    this.setPagination();
    // dont' need to load
  }

  public rowClick(numericIndex: number, event: MouseEvent, row) {
    if (row[0].value) {
      this.getImagedDocument(row[0].value, this.displayDocuments.indexOf(row));
    }
  }
}
